import { asLazy } from 'shared/utils/lazy.utils.js';

export { default as LoginPage } from './pages/LoginPage/index.js';
export { LoginSuccessPage } from './pages/LoginSuccessPage/LoginSuccessPage.js';
export { JoinFormType } from './pages/RegisterFormPage/RegisterFormPage.effects.js';
export { AuthLayout } from './components/AuthLayout/index.js';

export const GettingStarted = asLazy(
  import('./pages/RegisterCR/GettingStarted/GettingStarted.js'),
  'GettingStarted',
);
export const RegisterCRForm = asLazy(
  import('./pages/RegisterCR/RegisterCRForm/RegisterCRForm.js'),
  'RegisterCRForm',
);
export const RegisterFormPage = asLazy(
  import('./pages/RegisterFormPage/RegisterFormPage.js'),
  'RegisterFormPage',
);
